import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { HashRouter } from "react-router-dom";
import "./i18n";
import { Provider } from "react-redux";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";

import store from "./store";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<Provider store={store}>
		<React.Fragment>
			<HashRouter>
				<LocalizationProvider dateAdapter={AdapterMoment}>
					<App />
				</LocalizationProvider>
			</HashRouter>
		</React.Fragment>
	</Provider>,
);

serviceWorker.unregister();
